import { FunctionComponent, SVGProps } from 'react';
import merge from 'lodash/merge';
import styled, { css, CSSProperties } from 'styled-components';
import { breakpoint, BreakpointProp } from '../../utils/styles/breakpoints';

interface IconBaseProps {
    stroke?: BreakpointProp<CSSProperties['stroke']>;
    fill?: BreakpointProp<CSSProperties['fill']>;
    fillOpacity?: BreakpointProp<CSSProperties['fillOpacity']>;
    fontSize?: BreakpointProp<CSSProperties['fontSize']>;
    size?: BreakpointProp<CSSProperties['fontSize']>;
    with?: BreakpointProp<CSSProperties['width']>;
    height?: BreakpointProp<CSSProperties['height']>;
}

export type IconProps = SVGProps<SVGSVGElement> & IconBaseProps;

const iconsModelStyles = (props: IconBaseProps) =>
    merge(
        breakpoint('fill', props.fill ?? 'currentColor'),
        breakpoint('fillOpacity', props.fillOpacity),
        breakpoint('stroke', props.stroke),
        breakpoint('fontSize', props.size || props.fontSize),
        breakpoint('width', props.with),
        breakpoint('height', props.height),
    );

export function createIconComponent(
    Component: FunctionComponent<SVGProps<SVGSVGElement>>,
): FunctionComponent<IconProps> {
    return styled(Component)<IconBaseProps>`
        display: block;
        user-select: none;
        width: 1em;
        height: 1em;
        flex-shrink: 0;
        transition-property: fill, stroke;
        transition-duration: 0.15s;
        transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);

        ${css<IconBaseProps>(iconsModelStyles)}
    `;
}
